import { Image } from "lucide-react";
import { SCREENSHOTS } from "../data/homepage";

export const Screenshot = ({ id, className = "", testId }) => {
  const s = SCREENSHOTS[id];
  if (s.src)
    return <img src={s.src} alt={s.alt} className={`w-full h-full ${s.fit === "contain" ? "object-contain bg-white p-3" : "object-cover object-top"} rounded-2xl border border-black/5 ${className}`} data-testid={testId || `screenshot-${id}`} loading="lazy" />;
  return (
    <figure
      role="img"
      aria-label={s.alt}
      title={s.alt}
      className={`relative w-full h-full min-h-[14rem] rounded-2xl border border-dashed border-[#1A3B2B]/30 bg-[#F3EFE8] overflow-hidden flex flex-col items-center justify-center text-center p-6 ${className}`}
      data-testid={testId || `screenshot-${id}`}
    >
      <span className="absolute top-3 left-3 text-[10px] uppercase tracking-widest text-[#1A3B2B]/70 bg-white/70 px-2 py-1 rounded-full">{s.label}</span>
      <Image className="w-8 h-8 text-[#1A3B2B]/40 mb-3" strokeWidth={1.25} />
      <figcaption className="text-xs text-[#1A3B2B]/60 max-w-xs leading-relaxed">{s.alt}</figcaption>
    </figure>
  );
};
